import {
  ConfigurationOverrideModel,
  IConfigurationOverrideModel,
} from '@common/models/ConfigurationOverrideModel';
import { IModel, Model } from '@common/models/Model';
import {
  IScheduleJobModel,
  ScheduleJobModel,
} from '@common/models/ScheduleJobModel';
import { IObservableArray, makeObservable, observable } from 'mobx';

export interface IScheduledJobAndConfigOverridesModel extends IModel {
  registeredScheduledJobs: IScheduleJobModel[];
  configurationOverrides: IConfigurationOverrideModel[];
}

export class ScheduledJobAndConfigOverridesModel
  extends Model
  implements IScheduledJobAndConfigOverridesModel
{
  @observable registeredScheduledJobs: IObservableArray<IScheduleJobModel> =
    observable([]);
  @observable
  configurationOverrides: IObservableArray<IConfigurationOverrideModel> =
    observable([]);

  constructor(params: Partial<IScheduledJobAndConfigOverridesModel>) {
    super();
    makeObservable(this);
    this.registeredScheduledJobs = observable.array(
      params.registeredScheduledJobs?.map((sj) => new ScheduleJobModel(sj)) ||
        [],
    );
    this.configurationOverrides = observable.array(
      params.configurationOverrides?.map(
        (co) => new ConfigurationOverrideModel(co),
      ) || [],
    );
  }
}
